import * as React from 'react';

import classNames from 'classnames';

import {sortNavItems} from '../helpers';
import type {NavItem} from '../types';

import {SecondarySidebarLoading} from './secondary-sidebar-loading';
import {SidebarSection} from './sidebar-section';

import styles from './secondary-sidebar.module.css';

type Props = {
    navItems: NavItem[];
    footer?: React.ReactNode;
    isLoading?: boolean;
    isEmbedded?: boolean;
    id?: string;
};

export function SecondarySidebar(props: Props) {
    const sortedNavItems = sortNavItems(props.navItems);

    if (props.isLoading) {
        return <SecondarySidebarLoading />;
    }

    return (
        <div
            id={props.id}
            className={classNames(styles['secondary-sidebar-wrapper'], {
                [styles.embedded]: props.isEmbedded,
            })}
        >
            <ul
                className={classNames(styles['secondary-sidebar'], {
                    [styles.embedded]: props.isEmbedded,
                })}
            >
                {sortedNavItems.map((item) => (
                    <SidebarSection key={item.label} item={item} />
                ))}
            </ul>
            {props.footer && (
                <div
                    className={classNames(styles.footer, {
                        [styles.embedded]: props.isEmbedded,
                    })}
                >
                    {props.footer}
                </div>
            )}
        </div>
    );
}
